import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import { newModalStyle } from "../../reusable/styles";
import Style from "./modalResetTicket.module.css";
import Button from "../../common/button/button";

/**
 * While the document is being generated the modal body is replaced in place -
 * a second modal cannot be stacked on top of this one (see
 * .claude/rules/replace-in-place-modal.md), and closing this one would leave
 * the user without any feedback until the download notification appears.
 */
const ModalSendViaPingen = (props) => {
  const { t } = useTranslation();
  const { generating } = props;

  return (
    <Modal
      open={props.open}
      closeOnEsc
      // deliberate exits (esc, the close icon) stay available while generating
      // so a hung request can never trap the user; only the easily mistaken
      // overlay click is suppressed. Closing cannot double submit - the
      // confirm buttons are not rendered while generating.
      closeOnOverlayClick={!generating}
      onClose={props.close}
      center
      styles={newModalStyle({ width: "450px" })}
    >
      {generating ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "24px 0 8px",
          }}
        >
          <Loader type="Oval" color="#005a92" height={56} width={56} />
          <div style={{ marginTop: 18, fontSize: 15 }}>
            {t("ModalSendViaPingen.generating")}
          </div>
        </div>
      ) : (
        <>
          <div className="modal__title">
            {t("ModalSendViaPingen.title")}
          </div>

          <div style={{ marginTop: 20, fontSize: 15 }}>
            {t("ModalSendViaPingen.question")}
          </div>

          <div className={Style.buttonContainer} style={{ marginTop: 30 }}>
            <Button
              style={{ width: "35%" }}
              buttonStyle={{ width: "100%" }}
              variant="secondary"
              text={t("ModalSendViaPingen.no")}
              onClick={() => props.onConfirm(false)}
            />

            <Button
              style={{ width: "35%" }}
              buttonStyle={{ width: "100%" }}
              text={t("ModalSendViaPingen.yes")}
              onClick={() => props.onConfirm(true)}
            />
          </div>
        </>
      )}
    </Modal>
  );
};

export default ModalSendViaPingen;
